import * as React from "react";
import { Spin } from "antd";
import { EditForm } from "./EditForm";
import { CustomModal } from "../common/CustomModal";

export class EditModal extends React.Component {
  render() {
    const { visible, onClose, courseSelectedData, onSubmit, authToken } = this.props;

    return (
      <CustomModal
        width="1000px" /* Courses are wide, let's keep big-modal size wide */
        visible={visible}
        title="Edit Course"
        onClose={onClose}
      >
        {visible && courseSelectedData ? (
          <EditForm
            key={courseSelectedData._id + "_" + (courseSelectedData.updatedAt || "")}
            data={courseSelectedData}
            onSubmit={onSubmit}
            handleCancel={onClose}
            authToken={authToken}
          />
        ) : null}
      </CustomModal>
    );
  }
}
